import React, { useEffect, useState, useRef, useImperativeHandle, useMemo, forwardRef, useCallback } from 'react';
import AntGridScope, { buildGridScopeSegment } from './AntGridScope';

import AntSearchGrid from './AntSearchGrid';
import AntToolbar from './AntToolbar';
import AntWidgetSkeleton from './AntWidgetSkeleton';
import useWidgetFirstLoad from './AntWidgetSkeleton/useWidgetFirstLoad';

export default function (props) {
    const [loaded, markLoaded] = useWidgetFirstLoad(Boolean(props.url || props.table || props.loadFunc));

    let storageKey = props.storageKey
        ? props.storageKey
        : 'widget-grid-' +
          (props.name ? props.name : props.entityName ? props.entityName : props.API && props.API.entityName ? props.API.entityName : '');

    const grid = useRef();

    useEffect(() => {
        var ms = ((props.refreshIntervalSec ?? 0) | 0) * 1000;
        if (ms <= 0) return;
        var iv = setInterval(function () {
            try { if (grid.current && grid.current.refresh) grid.current.refresh(); } catch (e) {}
        }, ms);
        return () => clearInterval(iv);
    }, [props.refreshIntervalSec]);

    return (
        <AntGridScope
            segment={buildGridScopeSegment(
                'widget',
                props.widgetCode || props.name || props.table || props.entityName || (props.API && props.API.entityName)
            )}
        >
            {props.showTitle !== false && (
                <AntToolbar
                    title={props.title ? props.title : props.API && props.API.entityDisplay ? props.API.entityDisplay : props.entityDisplay}
                    showHelp={props.showHelp}
                    isH6={true}
                    upperCase={true}
                    // upperCase={props.upperCase}
                />
            )}

            <div className="ant-widget-skeleton-host">
                    {!loaded && (
                    <AntWidgetSkeleton
                        variant="grid"
                        overlay={true}
                        height={props.height ? props.height : 255}
                        rows={props.allowedPageSizes && props.allowedPageSizes.length > 0 ? props.allowedPageSizes[0] : 5}
                    />
                    )}
                    <AntSearchGrid
                    ref={grid}
                    API={props.API}
                    table={props.table}
                    url={props.url}
                    entityName={props.entityName}
                    entityDisplay={props.entityDisplay}
                    sortable={props.sortable}
                    focusable={props.focusable}
                    selectable={props.selectable}
                    selectionMode={props.selectionMode}
                    loadFunc={props.loadFunc}
                    searchConditions={props.searchConditions}
                    searchFields={props.searchFields}
                    remotePaging={props.remotePaging}
                    allowedPageSizes={props.allowedPageSizes ? props.allowedPageSizes : [5]}
                    cellStyles={props.cellStyles}
                    rowStyles={props.rowStyles}
                    showDownload={false}
                    showActionBar={props.showActionBar !== undefined ? props.showActionBar : false}
                    showSearchBar={props.showSearchBar}
                    showFieldChooser={props.showFieldChooser}
                    showIndex={false}
                    showDetail={props.showDetail}
                    showNote={props.showNote}
                    showAttachments={props.showAttachments}
                    showPriority={props.showPriority}
                    priorityField={props.priorityField}
                    showRefresh={props.showRefresh}
                    showImport={false}
                    showAdd={false}
                    showEdit={false}
                    showDelete={false}
                    locationRefresh={props.locationRefresh}
                    locationFilterBySelected={props.locationFilterBySelected}
                    locationDownload={props.locationDownload}
                    locationSearchBar={props.locationSearchBar}
                    columns={props.columns}
                    fields={props.fields}
                    actionItems={props.actionItems}
                    storageKey={storageKey}
                    settingsKey={props.settingsKey || props.storageKey}
                    keyExpr={props.keyExpr}
                    pagerHideable={props.pagerHideable !== undefined ? props.pagerHideable : false}
                    showPageSizeSelector={props.showPageSizeSelector !== undefined ? props.showPageSizeSelector : false}
                    hideHeaderMargin={true}
                    height={props.height ? props.height : 255}
                    onLoaded={markLoaded}
                    />
            </div>
        </AntGridScope>
    );
}
